import { Languages } from "lucide-react";
import { useCmsDocument } from "@/cms/CmsContentProvider";

export const LanguageToggle = ({ compact = false, className = "" }) => {
  const { locale, setLocale } = useCmsDocument();
  const nextLocale = locale === "de" ? "ar" : "de";
  const label = locale === "de" ? "العربية" : "Deutsch";

  return (
    <button
      type="button"
      onClick={() => setLocale(nextLocale)}
      aria-label={locale === "de" ? "Auf Arabisch wechseln" : "التبديل إلى الألمانية"}
      className={`inline-flex items-center justify-center gap-2 rounded-xl border border-[#cbd6e2] bg-white font-semibold text-[#193d6d] transition-colors hover:border-[#7a1516]/40 hover:text-[#7a1516] ${
        compact ? "h-10 min-w-10 px-2 text-xs" : "px-3 py-2 text-sm"
      } ${className}`}
    >
      <Languages size={17} aria-hidden="true" />
      {!compact && <span>{label}</span>}
      {compact && <span className="sr-only">{label}</span>}
    </button>
  );
};
